"use client";

import { useAbility } from "@/hooks/useAbility";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import { useMe } from "@/hooks/useMe";

/** Flag plus the per-user beta entitlement, without a scope permission check — for permission catalogs. */
export function useChangeOrderFeatureVisible(): boolean {
  const { me } = useMe();
  const { "pd-3-enable-change-orders": changeOrdersEnabled } = useFeatureFlags();
  return Boolean(changeOrdersEnabled && me?.data?.attributes.changeOrderAccess);
}

export function useChangeOrderAccess(scopeId?: string) {
  const { error, isLoading, refetch } = useMe();
  const { can } = useAbility();
  const isFeatureVisible = useChangeOrderFeatureVisible();
  const canRead = can("read", { scopeType: "POTENTIAL_CHANGE_ORDER", ...(scopeId ? { scopeId } : {}) });
  const hasAccess = isFeatureVisible && canRead;

  return { hasAccess, isError: Boolean(error), isLoading, refetch };
}
